import { AppComponent } from './app.component';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {MatDialogModule} from '@angular/material/dialog';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatGridListModule } from '@angular/material/grid-list';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatSelectModule} from '@angular/material/select';
import {MatCardModule} from '@angular/material/card';
import {MatBadgeModule} from '@angular/material/badge';
import {MatTableModule} from '@angular/material/table';

import { HttpClientModule }    from '@angular/common/http';
import {APP_BASE_HREF} from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CelestialPanelComponent } from './components/celestial-panel/celestial-panel.component';
import { GuildsPanelComponent } from './components/guilds-panel/guilds-panel.component';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

@NgModule({
  declarations: [
    AppComponent,
    CelestialPanelComponent,
    GuildsPanelComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatGridListModule,
    BrowserAnimationsModule,
    FormsModule,
    MatDialogModule,
    MatSelectModule,
    MatCardModule,
    MatBadgeModule,
    MatTableModule,
    MatProgressSpinnerModule
  ],
  providers: [{provide: APP_BASE_HREF, useFactory: getBaseUrl}],
  bootstrap: [AppComponent]
})
export class AppModule { }
